import React from 'react';
import { upsellRows } from '../data/content';
export function UpsellTable() {
  return <section className="w-full bg-ink-900 px-4 py-10 sm:px-6 sm:py-14" data-id="element-150" data-mp="1472yww18g0yz">
      <div className="mx-auto max-w-4xl" data-id="element-151" data-mp="1495wq28mmye9">
        <h2 className="text-center text-lg font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-152" data-mp="pj83v8zr5kiq">
          ¿Qué agrega el Tomo 2: Tráfico de la Calle?
        </h2>

        <div className="mt-6 hidden overflow-hidden rounded-xl border border-white/10 md:block" data-id="element-153" data-mp="1i7dnttizf5hi">
          <table className="w-full border-collapse text-left" data-id="element-154" data-mp="1n5xbpzh4yrci">
            <thead data-id="element-155" data-mp="1n5fg952ash5n">
              <tr className="bg-ink-700" data-id="element-156" data-mp="1n3ukjc48ys67">
                <th className="p-4 text-xs font-extrabold uppercase tracking-wide text-neutral-300" data-id="element-157" data-mp="187wkhir7d3op">
                  Situación
                </th>
                <th className="p-4 text-xs font-extrabold uppercase tracking-wide text-neutral-500" data-id="element-158" data-mp="1d9ubx09rb4sq">
                  ❌ Solo Tomo 1
                </th>
                <th className="p-4 text-xs font-extrabold uppercase tracking-wide text-gold-500" data-id="element-159" data-mp="1txc2h0dr0gq">
                  ✅ Sistema Completo
                </th>
              </tr>
            </thead>
            <tbody data-id="element-160" data-mp="w0shb73oglm5">
              {upsellRows.map(row => <tr key={row.situation} className="border-t border-white/10" data-id="element-161" data-mp="19zia4ajgrz4p">
                  <td className="bg-ink-800 p-4 text-[13px] text-neutral-300" data-id="element-162" data-mp="19xfg7ff6xlup">
                    {row.situation}
                  </td>
                  <td className="bg-ink-800 p-4 text-[13px] text-neutral-500" data-id="element-163" data-mp="1jx6613st3cog">
                    {row.without}
                  </td>
                  <td className="bg-ink-800 p-4 text-[13px] font-bold text-gold-400" data-id="element-164" data-mp="1ey3d2hq3owwu">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <ul className="mt-6 space-y-2.5 md:hidden" data-id="element-165" data-mp="1oqsbaawn4ea8">
          {upsellRows.map(row => <li key={row.situation} className="rounded-xl border border-white/10 bg-ink-800 p-4" data-id="element-166" data-mp="22m35dm328vdj">
              <p className="text-[13px] font-bold text-white" data-id="element-167" data-mp="vc82nz4co0ld">
                {row.situation}
              </p>
              <p className="mt-2 text-[13px] text-neutral-500" data-id="element-168" data-mp="zci5x40rccwj">
                <span className="font-semibold" data-id="element-169" data-mp="14cd1hkvh9qnx">❌ Solo Tomo 1:</span>{' '}
                {row.without}
              </p>
              <p className="mt-1 text-[13px] text-gold-400" data-id="element-170" data-mp="193mp6fxgujx6">
                <span className="font-semibold" data-id="element-171" data-mp="194xqm93fvfl4">✅ Sistema Completo:</span>{' '}
                {row.with}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}